import { resolveProp } from '@clearscore/helpers.resolve-props';

const getShowResetPasswordConfirmation = (state) => resolveProp('resetPassword.showResetPasswordConfirmation', state);

export default getShowResetPasswordConfirmation;
